import Vue, { VueConstructor } from 'vue';
import { Game, pickRole } from '@/services';

export default (Vue as VueConstructor<Vue & {
}>).extend({
    props: {
        game: Object as () => Game
    },
    data() {
        return {
            name: "",
            role: "" as "master" | "agent",
            team: "" as "A" | "B"
        };
    },
    computed: {
        masterAvailable(): boolean {
            return this.game.masters.length < 2;
        },
        canPlay(): boolean {
            return !!this.role && !!this.name && !!this.team;
        }
    },
    methods: {
        play() {
            pickRole(this.game.gameId, this.role, this.name, this.team).then((g) => {
                this.$modal.hide("picker");
                this.$emit("update-game", g.game, g.player);
            });
        }
    },
    mounted() {
        this.$modal.show("picker");
    }
})